import { isInGroup, removeRepeatingLinkParams } from '@frontend/utils';
import { fabric } from 'fabric';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { ICON_PREFIX_ID } from "@frontend/constants/templates-field-prefixes";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data', 'base_url', 'getIsLightweight']);

export function drawImageList({
   fields,
   data,
   canvas,
   id,
   group_fields,
   dimension,
}) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.includes(ICON_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data, base_url, getIsLightweight } = getScopePage();
  const is_lightweight = getIsLightweight();

  canvas_data[id].iconCoords = [];
  
  let index = 0;
  fields.forEach((field) => {
    const options = JSON.parse(field.options);
    const groupName = options["Group Name"];
    const visible = !options['Hidden'];

    if (field.type === "Image List" && (!group_fields || isInGroup(group_fields, field.name))) {
      const image_name = data[field.element_id];
      
      if (image_name && image_name !== "none") {
        let url = base_url + "/share?file=" + image_name;
        const offset_x = data[`${field.element_id}_offset_x`];
        const offset_y = data[`${field.element_id}_offset_y`];
        const angle = data[`${field.element_id}_angle`];
        const scale = parseFloat(data[`${field.element_id}_scale`]);
        const extension = image_name.split(".").slice(-1)[0];
        
        if (extension.toLowerCase() === "svg") {
          fabric.loadSVGFromURL(url, function (objects, opt) {
            const oImg = fabric.util.groupSVGElements(objects, opt);
            let r, r1;
            r = oImg.width / parseInt(options["Width"]);
            if (oImg.height / r > parseInt(options["Height"])) {
              r1 = oImg.height / r / parseInt(options["Height"]);
            } else {
              r1 = 1;
            }
            
            oImg.set({
              id: ICON_PREFIX_ID + index,
              groupName: groupName,
              element_id: field.element_id,
              order: parseInt(options["Order"]),
              left: canvas_data[id].spacingFieldPosition[field.name]
                ? canvas_data[id].spacingFieldPosition[field.name].x
                : parseInt(options["X"]) +
                parseFloat(offset_x) -
                dimension[2] +
                dimension[4].x,
              top:
                parseInt(options["Y"]) +
                parseFloat(offset_y) -
                dimension[3] +
                dimension[4].y,
              angle: parseInt(angle),
              selectable: options["Moveable"] === "Yes",
              evented: options["Moveable"] === "Yes",
              visible
            });
            
            oImg.scaleToWidth(oImg.width / r / r1);
            oImg.scaleToHeight(oImg.height / r / r1);
            
            oImg.set({
              scaleX: oImg.scaleX * scale,
              scaleY: oImg.scaleY * scale
            });
            
            canvas.add(oImg);
            
            canvas_data[id].iconCoords.push({
              x: parseInt(options["X"]),
              y: parseInt(options["Y"]),
              scaleX: oImg.scaleX / scale,
            });
            
            index++;
          });
        } else {
          // replace domain name from URL POR-2222
          if (url && url.includes('share?file=')) {
            url = removeRepeatingLinkParams(url, '&full_resolution');
          }

          fabric.Image.fromURL(url, function (oImg) {
            var r, r1;
            r = oImg.width / parseInt(options["Width"]);
            if (oImg.height / r > parseInt(options["Height"])) {
              r1 = oImg.height / r / parseInt(options["Height"]);
            } else {
              r1 = 1;
            }
            oImg.set({
              id: ICON_PREFIX_ID + index,
              groupName: groupName,
              element_id: field.element_id,
              order: parseInt(options["Order"]),
              left: canvas_data[id].spacingFieldPosition[field.name]
                ? canvas_data[id].spacingFieldPosition[field.name].x
                : parseInt(options["X"]) +
                parseFloat(offset_x) -
                dimension[2] +
                dimension[4].x,
              top:
                parseInt(options["Y"]) +
                parseFloat(offset_y) -
                dimension[3] +
                dimension[4].y,
              angle: parseInt(angle),
              selectable: options["Moveable"] === "Yes",
              evented: options["Moveable"] === "Yes",
              visible
            });
            oImg.scaleToWidth(oImg.width / r / r1);
            oImg.scaleToHeight(oImg.height / r / r1);
            oImg.set({ scaleX: oImg.scaleX * scale });
            oImg.set({ scaleY: oImg.scaleY * scale });
            canvas.add(oImg);
            canvas_data[id].iconCoords.push({
              x: parseInt(options["X"]),
              y: parseInt(options["Y"]),
              scaleX: oImg.scaleX / scale,
            });
            index++;
          });
        }
      }
    }
  });
}
